export const downloadReferrer = 'download'
export const storeRoute = 'store'
export const selectTargetRewardRoute = 'store/select-target-reward'
export const accountSummaryRoute = 'account/summary'
